import { mediaQuery } from '@/ui/utils';

export const variant = {
  small: mediaQuery.until('mobileLandscape'),
  large: mediaQuery.from('tablet'),
};
